module.exports = __webpack_public_path__ + "storeHome/img/mobile-enLimited-1111.4a7e6e85.png";